var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2637 2.65496C46.5985 2.06149 45.5993 2.0436 44.9133 2.61288L36.3326 9.73326C35.9337 10.0643 35.4115 10.2075 34.8996 10.1263L23.8869 8.38004C23.0064 8.24043 22.1562 8.76558 21.8868 9.61539L18.5178 20.2445C18.3612 20.7387 17.9994 21.1414 17.5248 21.3499L7.31624 25.8348C6.50005 26.1933 6.06871 27.0948 6.30155 27.9553L9.21392 38.7185C9.34931 39.2189 9.26268 39.7533 8.97615 40.1853L2.81286 49.4774C2.3201 50.2203 2.4446 51.2119 3.10572 51.8099L11.3748 59.2899C11.7592 59.6377 11.9753 60.1341 11.9678 60.6524L11.8065 71.8015C11.7937 72.6929 12.4345 73.4598 13.314 73.6054L24.3144 75.4275C24.8258 75.5122 25.2759 75.813 25.5498 76.253L31.4419 85.7194C31.9129 86.4763 32.8666 86.775 33.6852 86.422L43.9244 82.0075C44.4004 81.8023 44.9418 81.812 45.4101 82.0341L55.4847 86.8123C56.2902 87.1943 57.254 86.93 57.7518 86.1905L63.9789 76.941C64.2684 76.511 64.729 76.2265 65.2431 76.1602L76.3017 74.7331C77.1858 74.619 77.8537 73.8756 77.8727 72.9843L78.1107 61.8366C78.1217 61.3183 78.3554 60.8299 78.752 60.4962L87.2836 53.3169C87.9657 52.7429 88.1256 51.7564 87.6597 50.9964L81.833 41.4897C81.5621 41.0477 81.4946 40.5105 81.6479 40.0153L84.9436 29.3632C85.2071 28.5116 84.8083 27.5953 84.0055 27.2077L73.964 22.3603C73.4972 22.135 73.15 21.7195 73.0112 21.2201L70.0248 10.4772C69.786 9.61828 68.9551 9.06303 68.0702 9.17104L57.0021 10.522C56.4876 10.5848 55.9709 10.423 55.5841 10.0779L47.2637 2.65496Z",
    fill: "#FFC420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8475 41.544C62.0954 39.8063 61.174 37.2374 57.8671 36.6373C54.5602 36.0372 52.9125 38.9405 52.4437 41.524",
    stroke: "black",
    strokeWidth: 3.15083,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4287 40.8038C31.1782 39.59 31.8689 36.95 35.2031 36.5273C38.5373 36.1046 40.1357 38.7567 40.8188 41.3394",
    stroke: "black",
    strokeWidth: 3.15083,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4746 49.8127C54.7474 52.3494 51.6209 57.2259 44.9321 56.4391C42.6618 56.205 37.7263 54.3842 36.1462 48.9739",
    stroke: "black",
    strokeWidth: 3.15083,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateIcon);
export default __webpack_public_path__ + "static/media/private-icon.1c46486686872a39d0200830a7c15577.svg";
export { ForwardRef as ReactComponent };